module.exports = __webpack_public_path__ + "static/media/edit-file.e8f4445d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/edit-file.svg
// module id = 1056
// module chunks = 3